module.exports = __webpack_public_path__ + "static/media/estrela.671d0b65.svg";